import { render, staticRenderFns } from "./MainHeaderCollapse.vue?vue&type=template&id=07fd4ef3"
import script from "./MainHeaderCollapse.vue?vue&type=script&lang=js"
export * from "./MainHeaderCollapse.vue?vue&type=script&lang=js"
import "./MainHeaderCollapse.vue?vue&type=style&index=0&id=07fd4ef3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports